import Vue from 'vue';
import $ from 'jquery';
import { autorization } from '@/common/mixins/autorizationMixin';
import { checkStorageMixin } from '@/common/mixins/checkStorageMixin';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import ChangePasswordModal from '@/user/components/login/change-password/change-password.vue';
import axios from 'axios';
import { urls } from '@/common/constants/const-url';
import { NbrbAuthStatus } from '@/common/enums/nbrbAuthStatus';
import { AuthorizationType } from '@/user/enums/AuthorizationType';
import { inputModificationMixin } from '@/common/mixins/inputModificationMixin';

library.add(faEye, faEyeSlash);
export default Vue.extend({
    name: 'Login',
    components: {
        FontAwesomeIcon,
        ChangePasswordModalComponent: ChangePasswordModal,
    },
    mixins: [autorization, inputModificationMixin, checkStorageMixin],
    data: function () {
        return {
            container: '',
            userName: '',
            passwordLogin: '',
            passwordDigitalSignature: '',
            isPasswordLoginVisible: false,
            isPasswordDigitalVisible: false,
            containerList: [],
            selectedAuthorizationType: '',
            frameUrls: [],
            AuthorizationType,
        };
    },

    computed: {
        isLoginTab: function () {
            return this.selectedAuthorizationType === AuthorizationType.Login;
        },
        isDigitalTab: function () {
            return  this.selectedAuthorizationType === AuthorizationType.DigitalKey;
        },
        disabledLoginDigitalSignature: function () {
            return !this.container || !this.passwordDigitalSignature || this.isBusy || this.isLoading;
        },
        disabledLogin: function () {
            return !this.userName || !this.passwordLogin || this.isBusy || this.isLoading;
        },
    },
    watch: {
        msgError: function (value) {
            if (value) {
                this.$nextTick(() => {
                    $(this.$refs.msgError).on('closed.bs.alert', () => {
                        this.msgError = null;
                    });
                });
            }
        },
        container: function () {
            this.msgError = null;
        },
        userName: function () {
            this.msgError = null;
        },
        passwordLogin: function () {
            this.msgError = null;
        },
        passwordDigitalSignature: function () {
            this.msgError = null;
        },
    },
    created: function () {
        axios.get(urls.urlApplicationConfig)
            .then(response => {
                if (response.data.isSuccessful) {
                    this.frameUrls = response.data.viewModel.frameUrls;
                }
            });
    },
    methods: {
        changePasswordLoginVisibile: function () {
            this.isPasswordLoginVisible = !this.isPasswordLoginVisible;
        },
        changePasswordDigitalVisibile: function () {
            this.isPasswordDigitalVisible = !this.isPasswordDigitalVisible;
        },
        changeTab: function (authorizationType) {
            if (this.selectedAuthorizationType !== authorizationType) {
                this.selectedAuthorizationType = authorizationType;
                if (this.selectedAuthorizationType === AuthorizationType.Login) {
                    this.$nextTick(() => $(this.$refs.login).focus());
                    this.passwordLogin = '';
                    this.userName = '';
                } else {
                    this.passwordDigitalSignature = '';
                    this.getKeyContainerNames();
                }
                this.msgError = null;
            }            
        },
        updateKeyContainerNames: function () {
            this.msgError = null;
            this.getKeyContainerNames();
        },
        loginUserDigitalSignature: function () {
            this.loginWithSignature(this.container, this.passwordDigitalSignature)
                .then(result => {
                    if (result) {
                        location.href = urls.home;
                    }
                })
                .catch(error => {
                    if (error) {
                        this.msgError = error.errorMsg;
                    }
                });
        },
        loginGuest: function (username, password) {
            this.login(username, password)
                .then(() => {
                    location.href = urls.home;
                });
        },
        loginUser: function () {
            this.login(this.userName, this.passwordLogin)
                .then(() => {
                    location.href = urls.home;
                })
                .catch(error => {
                    if (error.status === NbrbAuthStatus.GuestFirstVisit) {
                        $('#changePasswordModal').modal('show');
                    }
                });
        },
        deleteForbiddenChars: function () {
            this.userName = this.userName.replace(/\s+/g, '');
        },
    },
    beforeDestroy() {
        this.isLoading = false;
    }
});


// WEBPACK FOOTER //
// ./login/components/login/login.ts